var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.56743 15.9515C7.42725 16.0521 7.259 16.1063 7.08641 16.1063C6.91381 16.1063 6.74557 16.0521 6.60538 15.9515C2.45739 12.9949 -1.94485 6.91333 2.5055 2.51881C3.72725 1.31698 5.37261 0.643779 7.08641 0.644532C8.80435 0.644532 10.4527 1.31883 11.6673 2.51796C16.1177 6.91247 11.7154 12.9931 7.56743 15.9515Z",
    stroke: "black",
    strokeWidth: 1.28846,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.08099 8.36949C7.53661 8.36949 7.97358 8.18849 8.29576 7.86632C8.61794 7.54414 8.79893 7.10717 8.79893 6.65154C8.79893 6.19591 8.61794 5.75895 8.29576 5.43677C7.97358 5.11459 7.53661 4.93359 7.08099 4.93359C6.62536 4.93359 6.18839 5.11459 5.86621 5.43677C5.54404 5.75895 5.36304 6.19591 5.36304 6.65154C5.36304 7.10717 5.54404 7.54414 5.86621 7.86632C6.18839 8.18849 6.62536 8.36949 7.08099 8.36949Z",
    stroke: "black",
    strokeWidth: 1.28846,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.6fa7fa1a.svg";
export { ForwardRef as ReactComponent };